import React, { useEffect, useState } from 'react'
import profile from '../../assests/images/profile_2.png'
import leader from '../../assests/images/leaderboard.svg'
import diamond from '../../assests/images/diamond.svg'
import { Link } from 'react-router-dom'
const Header = (props) => {
const [scrolled, setScrolled] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.pageYOffset > 0);
    };

    window.addEventListener('scroll', handleScroll);

    // Cleanup on unmount
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);
  return (
   <div className="header navbar-fixed">
  <nav  className={scrolled ? 'scrolled top_nav' : 'top_nav'}>
    <div className="h_left">
      <Link to={'/Profile'} className="a_logo">
        <img
          src={props.image?.trim() == '' ? profile : props.image}
          alt="profile"
          className="profile_log"
        />
        <div>
          <p className="greet">Hello,</p>
          <p className="users_nm">{props.name}</p>
        </div>
      </Link>
    </div>
    <div className="h_right">
      <Link  to={'/leaderboard'} className="btn_tp icon_sq">
        <img src={leader} alt="redeem" />
      </Link>
      <Link  to={'/Profile'} className="btn_tp">
        <img src={diamond} alt="Profile" />
        {props.dval}
      </Link>
    </div>
  </nav>
</div>

  )
}

export default Header
